import { TaxonomyPage, TaxonomySection } from '@zoopla/tracking';
import { Dispatch, SetStateAction } from 'react';
import { User } from '../../graphql.generated';

export type Segment = {
    page: TaxonomyPage;
    section: TaxonomySection;
    activity?: string | undefined;
};

export type ActionAfterAuth = {
    action: (user?: User) => void;
    eventLabel: string;
    segment?: Segment;
};

export type AuthModalMode = 'sign-in' | 'register' | 'quick-access';

export type AuthModalProps = {
    heading?: string;
    initialMode?: AuthModalMode;
    isShowing: boolean;
    close: (user?: User) => void;
    actionAfterAuth: ActionAfterAuth | null;
    resetActionAfterAuth?: () => void;
};

export interface SocialAuthProps extends AuthModalProps {
    onSocialAuth?: (user?: User) => void;
    shouldFetchUser?: boolean;
    setCurrentStep?: Dispatch<SetStateAction<AuthModalStepKeys>>;
}

export type AuthModalTracking = {
    taxonomy: {
        registration_platform?: string;
        signed_in_status?: string;
    };
};

export type AuthModalStep = {
    title?: string;
    component: JSX.Element;
    trackingCategory?: string;
};

export enum AuthModalStepKeys {
    FORM_TABS = 'formTabs',
    PREFERENCES = 'preferences',
    QUICK_ACCESS = 'quickAccess',
    YOUR_SITUATION = 'yourSituation'
}

export type AuthModalStepsConfig = {
    [key in AuthModalStepKeys]: AuthModalStep;
};
